<template>
  <Modal
    ref="createSubAccountSuccessModalRef"
    @onPositiveActionClick="closeSuccessModal"
    positiveActionText="Tamam"
    title="Alt hesabınızı oluşturduk."
    type="success"
  >
    <template v-slot:body>
      <p class="modal-text">Alt hesabın sahibi, telefonuna SMS ile gelen şifre ve belirlediğiniz kullanıcı adı ile hesaba giriş yapabilir.</p>
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { Modal } from "@n11/so-ui-components";

const createSubAccountSuccessModalRef = ref();

const openSuccessModal = () => createSubAccountSuccessModalRef?.value?.openModal();
const closeSuccessModal = () => createSubAccountSuccessModalRef?.value?.hiddenModal();

defineExpose({
  openSuccessModal,
})

</script>

<style lang="scss" scoped>
.modal-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.05px;
}
</style>
